module.exports = __webpack_public_path__ + "resources/img/img_hi_psm.c354280c3e6c2951a45663930d8f4eef.png";